import { UUID } from '../../entities/uuid.model';
import { INotification } from './notification.model';

export class NotificationAffectation implements INotification {
  constructor(
    public readonly idAffectation: UUID,
    public readonly title: string | undefined,
    public readonly body: string | undefined
  ) {}
}
